import { ActionService, type FormEditDraftActionCommand } from '@acme/api';
import {
  confirmRequested,
  deleteRequested,
  rejectRequested,
} from '@features/applicationActions';
import type { ApplicationFormActionHandlers } from '@widgets/applicationForm';
import { useUnit } from 'effector-react';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function useEditApplicationActionHandlers():
  | ApplicationFormActionHandlers
  | undefined {
  const { id } = useParams();
  const navigate = useNavigate();
  const { onConfirmRequested, onRejectRequested, onDeleteRequested } = useUnit({
    onConfirmRequested: confirmRequested,
    onRejectRequested: rejectRequested,
    onDeleteRequested: deleteRequested,
  });

  return useMemo(
    () =>
      id
        ? {
            onConfirm: (actionId: string) => onConfirmRequested({ actionId }),
            onReject: (actionId: string) => onRejectRequested({ actionId }),
            onDelete: (actionId: string) => onDeleteRequested({ actionId }),

            onFormEditDraft: async (
              actionId: string,
              requestBody: FormEditDraftActionCommand
            ) => {
              await ActionService.postApiV1ActionFormEditDraft({
                id: actionId,
                requestBody,
              });
              navigate(`/application/${id}`);
            },
          }
        : undefined,
    [id, navigate, onConfirmRequested, onRejectRequested, onDeleteRequested]
  );
}
